// Module
var code = `<section class="carousel" ng-if="show"><div class="page_header"><h3 ng-bind="title"></h3><a class="carousel-header-link" data-isource="{{isource}}" href="#" ng-bind="ctaText" ng-click="clearHistory()"></a></div><gi-carousel></gi-carousel></section> `;
// Exports
var _module_exports =code;;
var path = 'carousels/recent.html.slim';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;